import React, { Component } from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import CreditLimitForm from "../financials/Credit/CreditForm";

const actions = { closeModal };

const creditLimitModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Apply for Credit Limit" onClose={closeModal}>
      <CreditLimitForm />
    </Modal>
  );
};

export default connect(
  null,
  actions
)(creditLimitModal);
